










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BffIconLabel extends Vue {
  //   @Prop({ default: '~@/assets/images/line.png' }) imgSrc!: String;

  @Prop({ default: '' }) bgClass!: String;

  @Prop({ default: '' }) upText!: String;

  @Prop({ default: '' }) downText!: String;
}
